import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { shareReplay, switchMap } from 'rxjs/operators';
import { APIService, KPI } from '../api';

@Injectable()
export class InvestmentExecutionsService {

  private _investmentExecutions$: Observable<KPI.InvestmentExecution[]>;
  private investmentExecutionsRefresh$ = new BehaviorSubject<void>(null);

  constructor(private api: APIService) {
  }

  public get investmentExecutions$(): Observable<KPI.InvestmentExecution[]> {
    if (!this._investmentExecutions$) {
      this._investmentExecutions$ = this.investmentExecutionsRefresh$.pipe(
        switchMap(() => this.api.investments_investment_execution()),
        shareReplay(1),
      );
    }

    return this._investmentExecutions$;
  }

  public refreshInvestmentExecutions(): void {
    this.investmentExecutionsRefresh$.next();
  }
}
